import { Col, InputField, Label, ModalPopup, ReactSelectBox, Row, Tooltip, EventHandler } from "client/CommonComponents";
import './AssetType.scss'
import { MultiSelect } from '@softura/customcomponent'
import { AttributeName, CONSTANTS } from "client/utils/constants";
import { isNumber } from "utils";
import EqClassCodeList from "../EqClassCodeList";

const YearField = (props: any) => {
const { catalogItemValues, handleOnChange, catalogItemErrors, onPopupFilterModel, yearOption} = props

return <>
    <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
      <div className="label-addnew-block">
        <Label required data-attribute="AssetType_Default_Label">Year</Label>
        <EventHandler onEvent={() => onPopupFilterModel('Year')} data-attribute="AssetType_Default_EventHandler">
          <a className="fs-12">Add New</a>
        </EventHandler>
      </div>
      <Tooltip content={catalogItemValues?.year?.label ?? ''}  data-attribute="AssetType_Default_Tooltip">
        <ReactSelectBox
          isSearchable={true}
          name='year'
          placeholder="Select Year"
          options={yearOption}
          value={catalogItemValues?.year ?? ''}
          onChange={(selectedOption: any) => handleOnChange(selectedOption, 'year')}
          className={catalogItemErrors?.year ? 'controlValidation' : ""}
         data-attribute="AssetType_year_SearchSelectBox" />
      </Tooltip>
      {catalogItemErrors?.year ? <p className='validMessage'>{catalogItemErrors?.year}</p> : ""}
    </Col>
  </>
}

const EqClassCodeField = (props: any) => {
const {catalogItemValues, handleOnChange, catalogItemErrors,  onPopupFilterModel, eqClassCodeOption, handleClickShowEqClassCodeList} = props

  return <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
    <div className="label-addnew-block">
      <div className="label-addnew-block mt-1">
        <Label required data-attribute="AssetType_Default_Label_2">Eq Class Code</Label>
        <EventHandler onEvent={handleClickShowEqClassCodeList} data-attribute="AssetType_Default_EventHandler_2">
          <span className="fa fa-clipboard"></span>
        </EventHandler>
      </div>
      <EventHandler onEvent={() => onPopupFilterModel('Eq Class Code')} data-attribute="AssetType_Default_EventHandler_3">
        <a className="fs-12">Add New</a>
      </EventHandler>
    </div>
    <Tooltip content={catalogItemValues?.eqClassCode?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_2">
      <ReactSelectBox
        isSearchable={true}
        name="eqClassCode"
        options={eqClassCodeOption}
        placeholder="Select Eq Class Code"
        value={catalogItemValues?.eqClassCode ?? ''}
        onChange={(selectedOption: any) => handleOnChange(selectedOption, 'eqClassCode')}
        className={catalogItemErrors?.eqClassCode ? 'controlValidation' : ""}
       data-attribute="AssetType_eqClassCode_SearchSelectBox" />
    </Tooltip>
    {catalogItemErrors?.eqClassCode ? <p className='validMessage'>{catalogItemErrors?.eqClassCode}</p> : ""}
  </Col>
}

const AssetType = (props: any) => {

  const { 
    catalogItemValues, 
    handleOnChange, 
    catalogItemErrors, 
    priceFormat, 
    assetTypeValue,
    constructionEquipmentWithSubCategory,
    standardizedEquipmentWithSubCategory,
    snowWithSubCategory,
    editFilterModel
  } = props

  const getVehicleLevelToolTip = () => {
    let vehicleleveltoolltip: any = ''
    if (catalogItemValues?.vehicleLevel?.length) {
      catalogItemValues?.vehicleLevel?.map((val: any) => {
        if (vehicleleveltoolltip != '') {
          vehicleleveltoolltip = vehicleleveltoolltip + ', ' + val?.label
        } else {
          vehicleleveltoolltip = val?.label
        }
      })
      return vehicleleveltoolltip;
    }
  }

  return (<>
    <Row>
      {props?.assetTypeValue !== CONSTANTS.VEHICLE ? <p className="fs-12 mb-2"><b>Asset Type Selection</b></p> : ''}
      {
        props?.assetTypeValue === CONSTANTS.VEHICLE ? <>
          <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
            <Label required data-attribute="AssetType_Default_Label_3">Vehicle Type</Label>
            <Tooltip content={catalogItemValues?.vehicleType?.label} data-attribute="AssetType_Default_Tooltip_3">
            <ReactSelectBox
              isSearchable = {true}
              name='vehicleType'
              placeholder="Select Vehicle Type"
              options={props?.vehicleTypeOption}
              value={catalogItemValues?.vehicleType ?? ''}
              onChange={(selectedOption: any) => handleOnChange(selectedOption, 'vehicleType')}
              className={catalogItemErrors?.vehicleType ? 'controlValidation' : "" }
             data-attribute="AssetType_vehicleType_SearchSelectBox" />
            </Tooltip>
            {catalogItemErrors?.vehicleType ? <p className='validMessage'>{catalogItemErrors?.vehicleType}</p> : ""}
          </Col>
          <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
            <div className="label-addnew-block">
                <Label required data-attribute="AssetType_Default_Label_4">Class Type</Label>
                <EventHandler onEvent={() => { props?.onPopupFilterModel('Class Type') }} data-attribute="AssetType_Default_EventHandler_4">
                  <a className="fs-12">Add New</a>
                </EventHandler>
            </div>
            <Tooltip content={catalogItemValues?.classType?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_4">
            <ReactSelectBox
              isSearchable = {true}
              name='classType'
              placeholder="Select Class Type"
              options={props?.classTypeOption}
              value={catalogItemValues?.classType ?? ''}
              onChange={(selectedOption: any) => handleOnChange(selectedOption, 'classType')}
              className={catalogItemErrors?.classType ? 'controlValidation' : "" }
             data-attribute="AssetType_classType_SearchSelectBox" />
            </Tooltip>
            {catalogItemErrors?.classType ? <p className='validMessage'>{catalogItemErrors?.classType}</p> : ""}
          </Col>
          {catalogItemValues?.vehicleType?.orderRequestType === CONSTANTS.MANAGEMENT_VEHICLE ?
            <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
              <div className="label-addnew-block">
                <Label required data-attribute="AssetType_Default_Label_5">{AttributeName.ASSIGNMENT_GROUPS}</Label>
                <EventHandler onEvent={()=>{props?.onPopupFilterModel('Vehicle Level')}} data-attribute="AssetType_Default_EventHandler_5">
                  <a className="fs-12">Add New</a>
                </EventHandler>
              </div>
               <Tooltip content={getVehicleLevelToolTip() ?? ''}  data-attribute="AssetType_Default_Tooltip_5"> 
              <MultiSelect
                name='vehicleLevel'
                value={catalogItemValues?.vehicleLevel || []}
                onChange={(value: any) => handleOnChange(value, 'vehicleLevel')}
                options={props?.vehicleLevelOption}
                className={catalogItemErrors?.vehicleLevel ? 'controlValidation' : "" }
                closeOnChangedValue={false}
              />
              </Tooltip>
              {catalogItemErrors?.vehicleLevel ? <p className='validMessage'>{catalogItemErrors?.vehicleLevel}</p> : ""}
            </Col>
            : null
          }
          <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
            <div className="label-addnew-block">
              <Label required data-attribute="AssetType_Default_Label_6">Group Type</Label>
              <EventHandler onEvent={() => { props?.onPopupFilterModel('Group Type') }} data-attribute="AssetType_Default_EventHandler_6">
                <a className="fs-12">Add New</a>
              </EventHandler>
            </div>
            <Tooltip content={catalogItemValues?.groupType?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_6">
            <ReactSelectBox
              isSearchable = {true}
              name='groupType'
              placeholder="Select Group Type"
              options={props?.groupTypeOption}
              value={catalogItemValues?.groupType ?? ''}
              onChange={(selectedOption: any) => handleOnChange(selectedOption, 'groupType')}
              className={catalogItemErrors?.groupType ? 'controlValidation' : "" }
             data-attribute="AssetType_groupType_SearchSelectBox" />
            </Tooltip>
            {catalogItemErrors?.groupType ? <p className='validMessage'>{catalogItemErrors?.groupType}</p> : ""}
          </Col>
          <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
            <div className="label-addnew-block">
              <Label required data-attribute="AssetType_Default_Label_7">Vehicle Class</Label>
              <EventHandler onEvent={() => { props?.onPopupFilterModel('Vehicle Class') }} data-attribute="AssetType_Default_EventHandler_7">
                <a className="fs-12">Add New</a>
              </EventHandler>
            </div>
            <Tooltip content={catalogItemValues?.vehicleClass?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_7">
            <ReactSelectBox
              isSearchable = {true}
              name='vehicleClass'
              placeholder="Select Vehicle Class"
              options={props?.vehicleClassOption}
              value={catalogItemValues?.vehicleClass ?? ''}
              onChange={(selectedOption: any) => handleOnChange(selectedOption, 'vehicleClass')}
              className={catalogItemErrors?.vehicleClass ? 'controlValidation' : "" }
             data-attribute="AssetType_vehicleClass_SearchSelectBox" />
            </Tooltip>
            {catalogItemErrors?.vehicleClass ? <p className='validMessage'>{catalogItemErrors?.vehicleClass}</p> : ""}
          </Col>
          <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
            <div className="label-addnew-block">
              <Label required data-attribute="AssetType_Default_Label_8">Gross Vehicle Weight Rating</Label>
              <EventHandler onEvent={() => { props?.onPopupFilterModel('Gross Vehicle Weight Rating') }} data-attribute="AssetType_Default_EventHandler_8">
                <a className="fs-12">Add New</a>
              </EventHandler>
            </div>
            <Tooltip content={catalogItemValues?.vehicleGrossWeightRating?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_8">
            <ReactSelectBox
              isSearchable = {true}
              name='vehicleGrossWeightRating'
              placeholder="Select Gross Vehicle Weight Rating"
              options={props?.vehicleGrossWeightOption}
              value={catalogItemValues?.vehicleGrossWeightRating ?? ''}
              onChange={(selectedOption: any) => handleOnChange(selectedOption, 'vehicleGrossWeightRating')}
              className={catalogItemErrors?.vehicleGrossWeightRating ? 'controlValidation' : "" }
             data-attribute="AssetType_vehicleGrossWeightRating_SearchSelectBox" />
            </Tooltip>
            {catalogItemErrors?.vehicleGrossWeightRating ? <p className='validMessage'>{catalogItemErrors?.vehicleGrossWeightRating}</p> : ""}
          </Col>
          <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
            <Label required data-attribute="AssetType_Default_Label_9">CDL</Label>
            <Tooltip content={catalogItemValues?.cdl?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_9">
            <ReactSelectBox
              isSearchable = {true}
              name='cdl'
              placeholder="Select CDL"
              options={props?.cdlOption}
              value={catalogItemValues?.cdl ?? ''}
              onChange={(selectedOption: any) => handleOnChange(selectedOption, 'cdl')}
              className={catalogItemErrors?.cdl ? 'controlValidation' : "" }
             data-attribute="AssetType_cdl_SearchSelectBox" />
            </Tooltip>
            {catalogItemErrors?.cdl ? <p className='validMessage'>{catalogItemErrors?.cdl}</p> : ""}
          </Col>
          <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
            <div className="label-addnew-block">
              <Label required data-attribute="AssetType_Default_Label_10">Make</Label>
              <EventHandler onEvent={()=>{props?.onPopupFilterModel('Make')}} data-attribute="AssetType_Default_EventHandler_9">
                <a className="fs-12">Add New</a>
              </EventHandler>
            </div>
            <Tooltip content={catalogItemValues?.make?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_10">
            <ReactSelectBox
              isSearchable = {true}
              name='make'
              placeholder="Select Make"
              options={props?.makeOption}
              value={catalogItemValues?.make ?? ''}
              onChange={(selectedOption: any) => handleOnChange(selectedOption, 'make')}
              className={catalogItemErrors?.make ? 'controlValidation' : "" }
             data-attribute="AssetType_make_SearchSelectBox" />
            </Tooltip>
            {(catalogItemErrors?.make || catalogItemErrors?.manufacturer) ? <p className='validMessage'>{catalogItemErrors?.make || catalogItemErrors?.manufacturer}</p> : ""}
          </Col>
          <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
            <div className="label-addnew-block">
              <Label required data-attribute="AssetType_Default_Label_11">Model</Label>
              <EventHandler onEvent={props?.handleClickAddModel} data-attribute="AssetType_Default_EventHandler_10">
                <a className="fs-12">Add New</a>
              </EventHandler>
            </div>
            <Tooltip content={catalogItemValues?.model?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_11">
            <ReactSelectBox
              isSearchable = {true}
              name='model'
              placeholder="Select Model"
              options={props?.modelOption}
              value={catalogItemValues?.model ?? ''}
              onChange={(selectedOption: any) => handleOnChange(selectedOption, 'model')}
              className={catalogItemErrors?.model ? 'controlValidation' : "" }
             data-attribute="AssetType_model_SearchSelectBox" />
            </Tooltip>
            {catalogItemErrors?.model ? <p className='validMessage'>{catalogItemErrors?.model}</p> : ""}
          </Col>
          <YearField catalogItemValues={catalogItemValues} handleOnChange={handleOnChange} catalogItemErrors={catalogItemErrors} onPopupFilterModel={props?.onPopupFilterModel} yearOption={props.yearOption}/>
          <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
            <div className="label-addnew-block">
              <Label required data-attribute="AssetType_Default_Label_12"># of Doors</Label>
              <EventHandler onEvent={()=>{props?.onPopupFilterModel('# of Doors')}} data-attribute="AssetType_Default_EventHandler_11">
                <a className="fs-12">Add New</a>
              </EventHandler>
            </div>
            <Tooltip content={catalogItemValues?.noOfDoors?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_12">
            <ReactSelectBox
              isSearchable = {true}
              name='noOfDoors'
              placeholder="Select # of Doors"
              options={props?.doorsOption}
              value={catalogItemValues?.noOfDoors ?? ''}
              onChange={(selectedOption: any) => handleOnChange(selectedOption, 'noOfDoors')}
              className={catalogItemErrors?.noOfDoors ? 'controlValidation' : "" }
             data-attribute="AssetType_noOfDoors_SearchSelectBox" />
            </Tooltip>
            {catalogItemErrors?.noOfDoors ? <p className='validMessage'>{catalogItemErrors?.noOfDoors}</p> : ""}
          </Col>
          <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
            <div className="label-addnew-block">
              <Label required data-attribute="AssetType_Default_Label_13">Trim</Label>
              <EventHandler onEvent={() => { props?.onPopupFilterModel('Trim') }} data-attribute="AssetType_Default_EventHandler_12">
                <a className="fs-12">Add New</a>
              </EventHandler>
            </div>
            <Tooltip content={catalogItemValues?.trim?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_13">
            <ReactSelectBox
              isSearchable = {true}
              name='trim'
              placeholder="Select Trim"
              options={props?.trimOption}
              value={catalogItemValues?.trim ?? ''}
              onChange={(selectedOption: any) => handleOnChange(selectedOption, 'trim')}
              className={catalogItemErrors?.trim ? 'controlValidation' : "" }
             data-attribute="AssetType_trim_SearchSelectBox" />
            </Tooltip>
            {catalogItemErrors?.trim ? <p className='validMessage'>{catalogItemErrors?.trim}</p> : ""}
          </Col>
          <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width Edit_Addnew'>
            <div className="label-addnew-block">
              <Label required data-attribute="AssetType_Default_Label_14">Capacity</Label>
              <div className="edit-addnew-links">
                {catalogItemValues?.vehicleType?.label == CONSTANTS.PRODUCTION_VEHICLE ?
                  <EventHandler onEvent={() => { editFilterModel('Capacity', props?.capacityOption) }} data-attribute="AssetType_Default_EventHandler_13">
                    <a className="fs-12 edit_link">Edit</a>
                  </EventHandler>
                : null}
                <EventHandler onEvent={() => { props?.onPopupFilterModel('Capacity') }} data-attribute="AssetType_Default_EventHandler_14">
                  <a className="fs-12">Add New</a>
                </EventHandler>
              </div>
            </div>
            <Tooltip content={catalogItemValues?.truckSize?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_14">
              <ReactSelectBox
                isSearchable={true}
                name='truckSize'
                placeholder="Select Capacity"
                options={props?.capacityOption}
                value={catalogItemValues?.truckSize ?? ''}
                onChange={(selectedOption: any) => handleOnChange(selectedOption, 'truckSize')}
                className={catalogItemErrors?.truckSize ? 'controlValidation' : "" }
               data-attribute="AssetType_truckSize_SearchSelectBox" />
            </Tooltip>
            {catalogItemErrors?.truckSize ? <p className='validMessage'>Please provide Capacity</p> : ""}
          </Col>
          <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
            <div className="label-addnew-block">
              <Label required data-attribute="AssetType_Default_Label_15">BV Spec #</Label>
            </div>
            <Tooltip content={catalogItemValues?.bvSpec ?? ""} data-attribute="AssetType_Default_Tooltip_15">
            <InputField
              placeholder="Enter BV Spec #"
              name='bvSpec'
              onChange={(e: any) => handleOnChange(e?.target?.value, 'bvSpec')}
              value={catalogItemValues?.bvSpec}
              className={catalogItemErrors?.bvSpec ? 'controlValidation' : "" }
             data-attribute="AssetType_bvSpec_Input" />
            </Tooltip>
            {catalogItemErrors?.bvSpec ? <p className='validMessage'>{catalogItemErrors?.bvSpec}</p> : ""}
          </Col>
          <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
            <div className="label-addnew-block">
              <Label required data-attribute="AssetType_Default_Label_16">Upfit</Label>
              <EventHandler onEvent={()=>{props?.onPopupFilterModel('Upfit')}} data-attribute="AssetType_Default_EventHandler_15">
                <a className="fs-12">Add New</a>
              </EventHandler>
            </div>
            <Tooltip content={catalogItemValues?.upfit?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_16">
            <ReactSelectBox
              isSearchable = {true}
              name='upfit'
              placeholder="Select Upfit"
              options={props?.upfitOption}
              value={catalogItemValues?.upfit ?? ''}
              isDisabled = {catalogItemValues?.vehicleType?.label === 'Management Vehicle' ? true : false}
              onChange={(selectedOption: any) => handleOnChange(selectedOption, 'upfit')}
              className={catalogItemErrors?.upfit ? 'controlValidation' : "" }
             data-attribute="AssetType_upfit_SearchSelectBox" />
            </Tooltip>
            {catalogItemErrors?.upfit ? <p className='validMessage'>{catalogItemErrors?.upfit}</p> : ""}
          </Col>
          <EqClassCodeField 
            catalogItemValues={catalogItemValues} 
            handleOnChange={handleOnChange} 
            catalogItemErrors={catalogItemErrors}  
            onPopupFilterModel={props?.onPopupFilterModel} 
            eqClassCodeOption={props?.eqClassCodeOption} 
            handleClickShowEqClassCodeList={props?.handleClickShowEqClassCodeList}
            />
          <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
            <div className="label-addnew-block">
              <Label required data-attribute="AssetType_Default_Label_17">Drive Train</Label>
              <EventHandler onEvent={()=>{props?.onPopupFilterModel('Drive Train')}} data-attribute="AssetType_Default_EventHandler_16">
                <a className="fs-12">Add New</a>
              </EventHandler>
            </div>
            <Tooltip content={catalogItemValues?.driveTrain?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_17">
            <ReactSelectBox
              isSearchable = {true}
              name='driveTrain'
              placeholder="Select Drive Train"
              options={props?.driveTrainOption}
              value={catalogItemValues?.driveTrain ?? ''}
              onChange={(selectedOption: any) => handleOnChange(selectedOption, 'driveTrain')}
              className={catalogItemErrors?.driveTrain ? 'controlValidation' : "" }
             data-attribute="AssetType_driveTrain_SearchSelectBox" />
            </Tooltip>
            {catalogItemErrors?.driveTrain ? <p className='validMessage'>{catalogItemErrors?.driveTrain}</p> : ""}
          </Col>
          <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
            <div className="label-addnew-block">
              <Label required data-attribute="AssetType_Default_Label_18">Power Type</Label>
              <EventHandler onEvent={()=>{props?.onPopupFilterModel('Power Type')}} data-attribute="AssetType_Default_EventHandler_17">
                <a className="fs-12">Add New</a>
              </EventHandler>
            </div>
            <Tooltip content={catalogItemValues?.fuelType?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_18">
            <ReactSelectBox
              isSearchable = {true}
              name='fuelType'
              placeholder="Select Power Type"
              options={props?.powerTypeOption}
              value={catalogItemValues?.fuelType ?? ''}
              onChange={(selectedOption: any) => handleOnChange(selectedOption, 'fuelType')}
              className={catalogItemErrors?.fuelType ? 'controlValidation' : "" }
             data-attribute="AssetType_fuelType_SearchSelectBox" />
            </Tooltip>
            {catalogItemErrors?.fuelType ? <p className='validMessage'>Please provide Power Type</p> : ""}
          </Col>
        </> : ''
      }
      {
       props?.assetTypeValue !== CONSTANTS.VEHICLE
          ? <>
            {props?.assetTypeValue !== CONSTANTS.UTILITY_VEHICLE ?
              <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
                <div className="label-addnew-block">
                  <Label required data-attribute="AssetType_Default_Label_19">Category</Label>
                  <EventHandler onEvent={(e: any) => {e.preventDefault();props?.onPopupFilterModel('Category')}} data-attribute="AssetType_Default_EventHandler_18">
                    <a className="fs-12">Add New</a>
                  </EventHandler>
                </div>
                <Tooltip content={catalogItemValues?.category?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_19">
                <ReactSelectBox
                  isSearchable = {true}
                  name='category'
                  placeholder="Select Category"
                  options={props?.categoryOption}
                  value={catalogItemValues?.category ?? ''}
                  onChange={(selectedOption: any) => handleOnChange(selectedOption, 'category')}
                  className={catalogItemErrors?.category ? 'controlValidation' : "" }
                 data-attribute="AssetType_category_SearchSelectBox" />
                </Tooltip>
                {catalogItemErrors?.category ? <p className='validMessage'>{catalogItemErrors?.category}</p> : ""}
              </Col>
              : null
            }
            {props?.assetTypeValue === CONSTANTS.CONSTRUCTION_EQUIPMENT &&
              constructionEquipmentWithSubCategory.includes(catalogItemValues?.category?.label || '') ?
              <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
                <div className="label-addnew-block">
                  <Label required data-attribute="AssetType_Default_Label_20">Category 2</Label>
                  <EventHandler onEvent={() => {props?.onPopupFilterModel('Category2')}} data-attribute="AssetType_Default_EventHandler_19">
                    <a className="fs-12">Add New</a>
                  </EventHandler>
                </div>
                <Tooltip content={catalogItemValues?.category2?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_20">
                <ReactSelectBox
                  isSearchable = {true}
                  name='category2'
                  placeholder="Select Category 2"
                  options={props?.category2Option}
                  value={catalogItemValues?.category2 ?? ''}
                  onChange={(selectedOption: any) => handleOnChange(selectedOption, 'category2')}
                  className={catalogItemErrors?.category2 ? 'controlValidation' : ""}
                 data-attribute="AssetType_category2_SearchSelectBox" />
                </Tooltip>
                {catalogItemErrors?.category2 ? <p className='validMessage'>{catalogItemErrors?.category2}</p> : ""}
              </Col>
              : null
            }
            {props?.assetTypeValue === CONSTANTS.STANDARIZED_EQUIPMENT &&
              standardizedEquipmentWithSubCategory.includes(catalogItemValues?.category?.label || '') ?
              <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
                <div className="label-addnew-block">
                  <Label required data-attribute="AssetType_Default_Label_21">Category 2</Label>
                  <EventHandler onEvent={() => {props?.onPopupFilterModel('Category2')}} data-attribute="AssetType_Default_EventHandler_20">
                    <a className="fs-12">Add New</a>
                  </EventHandler>
                </div>
                <Tooltip content={catalogItemValues?.category2?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_21">
                <ReactSelectBox
                  isSearchable = {true}
                  name='category2'
                  placeholder="Select Category 2"
                  options={props?.category2Option}
                  value={catalogItemValues?.category2 ?? ''}
                  onChange={(selectedOption: any) => handleOnChange(selectedOption, 'category2')}
                  className={catalogItemErrors?.category2 ? 'controlValidation' : ""}
                 data-attribute="AssetType_category2_SearchSelectBox_2" />
                </Tooltip>
                {catalogItemErrors?.category2 ? <p className='validMessage'>{catalogItemErrors?.category2}</p> : ""}
              </Col>
              : null
            }
              {props?.assetTypeValue === CONSTANTS.SNOW &&
              snowWithSubCategory.includes(catalogItemValues?.category?.label || '') ?
              <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
                <div className="label-addnew-block">
                  <Label required data-attribute="AssetType_Default_Label_22">Category Type</Label>
                  <EventHandler onEvent={() =>{props?.onPopupFilterModel('Category Type')}} data-attribute="AssetType_Default_EventHandler_21">
                    <a className="fs-12">Add New</a>
                  </EventHandler>
                </div>
                <Tooltip content={catalogItemValues?.categoryType?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_22">
                <ReactSelectBox
                  isSearchable = {true}
                  name='categoryType'
                  placeholder="Select Category Type"
                  options={props?.categoryTypeOption}
                  value={catalogItemValues?.categoryType ?? ''}
                  onChange={(selectedOption: any) => handleOnChange(selectedOption, 'categoryType')}
                  className={catalogItemErrors?.categoryType ? 'controlValidation' : ""}
                 data-attribute="AssetType_categoryType_SearchSelectBox" />
                </Tooltip>
                {catalogItemErrors?.categoryType ? <p className='validMessage'>{catalogItemErrors?.categoryType}</p> : ""}
              </Col>
              : null
            }
            <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
              <div className="label-addnew-block">
                <Label required data-attribute="AssetType_Default_Label_23">Make</Label>
                <EventHandler onEvent={()=>{props?.onPopupFilterModel('Make')}} data-attribute="AssetType_Default_EventHandler_22">
                  <a className="fs-12">Add New</a>
                </EventHandler>
              </div>
              <Tooltip content={catalogItemValues?.make?.label ? catalogItemValues?.make?.label : catalogItemValues?.manufacturer?.label || ''}  data-attribute="AssetType_Default_Tooltip_23">
              <ReactSelectBox
                isSearchable = {true}
                name= {'manufacturer'}
                placeholder={`Select Make`}
                options={props?.makeOption}
                value={catalogItemValues?.make?.label ? catalogItemValues?.make : catalogItemValues?.manufacturer || ""}
                onChange={(selectedOption: any) => handleOnChange(selectedOption,'manufacturer')}
                className={catalogItemErrors?.make || catalogItemErrors?.manufacturer ? 'controlValidation' : "" }
               data-attribute="AssetType_manufacturer_SearchSelectBox" />
              </Tooltip>
              {(catalogItemErrors?.make || catalogItemErrors?.manufacturer) ? <p className='validMessage'>{catalogItemErrors?.make || catalogItemErrors?.manufacturer}</p> : ""}
            </Col>
            <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
              <div className="label-addnew-block">
                <Label required data-attribute="AssetType_Default_Label_24">Model</Label>
                <EventHandler onEvent={props?.handleClickAddModel} data-attribute="AssetType_Default_EventHandler_23">
                  <a className="fs-12">Add New</a>
                </EventHandler>
              </div>
              <Tooltip content={catalogItemValues?.model?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_24">
              <ReactSelectBox
                isSearchable = {true}
                name='model'
                placeholder="Select Model"
                options={props?.modelOption}
                value={catalogItemValues?.model ?? ''}
                onChange={(selectedOption: any) => handleOnChange(selectedOption, 'model')}
                className={catalogItemErrors?.model ? 'controlValidation' : "" }
               data-attribute="AssetType_model_SearchSelectBox_2" />
              </Tooltip>
              {catalogItemErrors?.model ? <p className='validMessage'>{catalogItemErrors?.model}</p> : ""}
            </Col>
            {props?.assetTypeValue === CONSTANTS.TRAILER ?
              <>
                <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
                  <div className="label-addnew-block">
                    <Label required data-attribute="AssetType_Default_Label_25">Length</Label>
                    <EventHandler onEvent={(e: any) => {e.preventDefault();props?.onPopupFilterModel('Length')}} data-attribute="AssetType_Default_EventHandler_24">
                      <a className="fs-12">Add New</a>
                    </EventHandler>
                  </div>
                  <Tooltip content={catalogItemValues?.length?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_25">
                  <ReactSelectBox
                    isSearchable = {true}
                    name='length'
                    options={props?.lengthOption}
                    placeholder="Select Length"
                    value={catalogItemValues?.length ?? ''}
                    onChange={(selectedOption: any) => handleOnChange(selectedOption, 'length')}
                    className={catalogItemErrors?.lengthAttr ? 'controlValidation' : "" }
                   data-attribute="AssetType_length_SearchSelectBox" />
                  </Tooltip>
                  {catalogItemErrors?.lengthAttr ? <p className='validMessage'>{catalogItemErrors?.lengthAttr}</p> : ""}
                </Col>
                <EqClassCodeField 
                  catalogItemValues={catalogItemValues} 
                  handleOnChange={handleOnChange} 
                  catalogItemErrors={catalogItemErrors}  
                  onPopupFilterModel={props?.onPopupFilterModel} 
                  eqClassCodeOption={props?.eqClassCodeOption} 
                  handleClickShowEqClassCodeList={props?.handleClickShowEqClassCodeList}
                  />
                <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
                  <div className="label-addnew-block">
                    <Label required data-attribute="AssetType_Default_Label_26">Power Type</Label>
                    <EventHandler onEvent={()=>{props?.onPopupFilterModel('Power Type')}} data-attribute="AssetType_Default_EventHandler_25">
                      <a className="fs-12">Add New</a>
                    </EventHandler>
                  </div>
                  <Tooltip content={catalogItemValues?.fuelType?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_26">
                  <ReactSelectBox
                    isSearchable = {true}
                    name='fuelType'
                    options={props?.powerTypeOption}
                    placeholder="Select Power Type"
                    value={catalogItemValues?.fuelType ?? ''}
                    onChange={(selectedOption: any) => handleOnChange(selectedOption, 'fuelType')}
                    className={catalogItemErrors?.fuelType ? 'controlValidation' : "" }
                   data-attribute="AssetType_fuelType_SearchSelectBox_2" />
                  </Tooltip>
                  {catalogItemErrors?.fuelType ? <p className='validMessage'>Please provide Power Type</p> : ""}
                </Col>
              </>
              :
              <YearField catalogItemValues={catalogItemValues} handleOnChange={handleOnChange} catalogItemErrors={catalogItemErrors} onPopupFilterModel={props?.onPopupFilterModel} yearOption={props.yearOption} />
            }
            {props?.assetTypeValue === CONSTANTS.STANDARIZED_EQUIPMENT ?
              <EqClassCodeField 
                catalogItemValues={catalogItemValues} 
                handleOnChange={handleOnChange} 
                catalogItemErrors={catalogItemErrors}  
                onPopupFilterModel={props?.onPopupFilterModel} 
                eqClassCodeOption={props?.eqClassCodeOption} 
                handleClickShowEqClassCodeList={props?.handleClickShowEqClassCodeList}
                />
              : null
            }
            {props?.assetTypeValue === CONSTANTS.UTILITY_VEHICLE ?
              <>
                <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
                  <Label required data-attribute="AssetType_Default_Label_27">Seating Capacity</Label>
                  <Tooltip content={catalogItemValues?.seatingCapacity?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_27">
                  <ReactSelectBox
                    isSearchable = {true}
                    name="seatingCapacity"
                    options={props?.seatingCapacityOption}
                    placeholder="Select Seating Capacity"
                    value={catalogItemValues?.seatingCapacity ?? ''}
                    onChange={(selectedOption: any) => handleOnChange(selectedOption, 'seatingCapacity')}
                    className={catalogItemErrors?.seatingCapacity ? 'controlValidation' : ""}
                   data-attribute="AssetType_seatingCapacity_SearchSelectBox" />
                  </Tooltip>
                  {catalogItemErrors?.seatingCapacity ? <p className='validMessage'>{catalogItemErrors?.seatingCapacity}</p> : ""}
                </Col>
                <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
                  <Label required data-attribute="AssetType_Default_Label_28">Capacity</Label>
                  <Tooltip content={catalogItemValues?.capacity?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_28">
                  <ReactSelectBox
                    isSearchable = {true}
                    name="capacity"
                    options={props?.capacityOption}
                    placeholder="Select Capacity"
                    value={catalogItemValues?.capacity ?? ''}
                    onChange={(selectedOption: any) => handleOnChange(selectedOption, 'capacity')}
                    className={catalogItemErrors?.capacity ? 'controlValidation' : ""}
                   data-attribute="AssetType_capacity_SearchSelectBox" />
                  </Tooltip>
                  {catalogItemErrors?.capacity ? <p className='validMessage'>{catalogItemErrors?.capacity}</p> : ""}
                </Col>
                <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
                  <Label required data-attribute="AssetType_Default_Label_29">Enclosed Cab</Label>
                  <Tooltip content={catalogItemValues?.enclosedCab?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_29">
                  <ReactSelectBox
                    isSearchable = {true}
                    name="enclosedCab"
                    options={props?.enclosedCabOption}
                    placeholder="Select Enclosed Cab"
                    value={catalogItemValues?.enclosedCab ?? ''}
                    onChange={(selectedOption: any) => handleOnChange(selectedOption, 'enclosedCab')}
                    className={catalogItemErrors?.enclosedCab ? 'controlValidation' : ""}
                   data-attribute="AssetType_enclosedCab_SearchSelectBox" />
                  </Tooltip>
                  {catalogItemErrors?.enclosedCab ? <p className='validMessage'>{catalogItemErrors?.enclosedCab}</p> : ""}
                </Col>
                <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
                  <div className="label-addnew-block">
                    <Label required data-attribute="AssetType_Default_Label_30">Drive Train</Label>
                    <EventHandler onEvent={()=>{props?.onPopupFilterModel('Drive Train')}} data-attribute="AssetType_Default_EventHandler_26">
                      <a className="fs-12">Add New</a>
                    </EventHandler>
                  </div>
                  <Tooltip content={catalogItemValues?.driveTrain?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_30">
                  <ReactSelectBox
                    isSearchable = {true}
                    name='driveTrain'
                    placeholder="Select Drive Train"
                    options={props?.driveTrainOption}
                    value={catalogItemValues?.driveTrain ?? ''}
                    onChange={(selectedOption: any) => handleOnChange(selectedOption, 'driveTrain')}
                    className={catalogItemErrors?.driveTrain ? 'controlValidation' : ""}
                   data-attribute="AssetType_driveTrain_SearchSelectBox_2" />
                  </Tooltip>
                  {catalogItemErrors?.driveTrain ? <p className='validMessage'>{catalogItemErrors?.driveTrain}</p> : ""}
                </Col>
                <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
                  <div className="label-addnew-block">
                    <Label required data-attribute="AssetType_Default_Label_31">Power Type</Label>
                    <EventHandler onEvent={()=>{props?.onPopupFilterModel('Power Type')}} data-attribute="AssetType_Default_EventHandler_27">
                      <a className="fs-12">Add New</a>
                    </EventHandler>
                  </div>
                  <Tooltip content={catalogItemValues?.fuelType?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_31">
                  <ReactSelectBox
                    isSearchable = {true}
                    name='fuelType'
                    placeholder="Select Power Type"
                    options={props?.powerTypeOption}
                    value={catalogItemValues?.fuelType ?? ''}
                    onChange={(selectedOption: any) => handleOnChange(selectedOption, 'fuelType')}
                    className={catalogItemErrors?.fuelType ? 'controlValidation' : ""}
                   data-attribute="AssetType_fuelType_SearchSelectBox_3" />
                  </Tooltip>
                  {catalogItemErrors?.fuelType ? <p className='validMessage'>Please provide Power Type</p> : ""}
                </Col>
                <EqClassCodeField 
                  catalogItemValues={catalogItemValues} 
                  handleOnChange={handleOnChange} 
                  catalogItemErrors={catalogItemErrors}  
                  onPopupFilterModel={props?.onPopupFilterModel} 
                  eqClassCodeOption={props?.eqClassCodeOption} 
                  handleClickShowEqClassCodeList={props?.handleClickShowEqClassCodeList}
                  />
              </>
              : null
            }
              <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
                <Label required data-attribute="AssetType_Default_Label_32">Price</Label>
                <Tooltip content={catalogItemValues?.price} data-attribute="AssetType_Default_Tooltip_32">
                <InputField
                  name='price'
                  placeholder='Enter Price'
                  onChange={(e: any) => handleOnChange(e?.target?.value, e?.target?.name)}
                  prefix={'$'}
                  onKeyPress={(event: any) => { isNumber(event) }}
                  value={catalogItemValues?.price}
                  onBlur={(event: any) => priceFormat(event, 'price')}
                  className={catalogItemErrors?.price ? 'controlValidation' : "" }
                 data-attribute="AssetType_price_Input" />
                </Tooltip>
                {catalogItemErrors?.price ? <p className='validMessage'>{catalogItemErrors?.price}</p> : ""}
              </Col>    
          </> : ''
      }
      {
        props?.assetTypeValue === CONSTANTS.SNOW ? <>
          <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
            <div className="label-addnew-block">
              <Label required data-attribute="AssetType_Default_Label_33">Size</Label>
              <EventHandler onEvent={(e: any) => {props?.onPopupFilterModel('Size')}} data-attribute="AssetType_Default_EventHandler_28">
                <a className="fs-12">Add New</a>
              </EventHandler>
            </div>
            <Tooltip content={catalogItemValues?.size?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_33">
            <ReactSelectBox
              isSearchable = {true}
              name="size"
              options={props?.sizeOption}
              placeholder="Select Size"
              value={catalogItemValues?.size ?? ''}
              onChange={(selectedOption: any) => handleOnChange(selectedOption, 'size')}
              className={catalogItemErrors?.size ? 'controlValidation' : "" }
             data-attribute="AssetType_size_SearchSelectBox" />
            </Tooltip>
            {catalogItemErrors?.size ? <p className='validMessage'>{catalogItemErrors?.size}</p> : ""}
          </Col>
          <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
            <div className="label-addnew-block">
              <Label required data-attribute="AssetType_Default_Label_34">Type</Label>
              <EventHandler onEvent={(e: any) => {props?.onPopupFilterModel('Type')}} data-attribute="AssetType_Default_EventHandler_29">
                <a className="fs-12">Add New</a>
              </EventHandler>
            </div>
            <Tooltip content={catalogItemValues?.type?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_34">
            <ReactSelectBox
              isSearchable = {true}
              name="type"
              options={props?.typeList}
              placeholder="Select Type"
              value={catalogItemValues?.type ?? ''}
              onChange={(selectedOption: any) => handleOnChange(selectedOption, 'type')}
              className={catalogItemErrors?.type ? 'controlValidation' : "" }
             data-attribute="AssetType_type_SearchSelectBox" />
            </Tooltip>
            {catalogItemErrors?.type ? <p className='validMessage'>{catalogItemErrors?.type}</p> : ""}
          </Col>
          <EqClassCodeField 
            catalogItemValues={catalogItemValues} 
            handleOnChange={handleOnChange} 
            catalogItemErrors={catalogItemErrors}  
            onPopupFilterModel={props?.onPopupFilterModel} 
            eqClassCodeOption={props?.eqClassCodeOption} 
            handleClickShowEqClassCodeList={props?.handleClickShowEqClassCodeList}
            />
        </> : null
      }
      {
        props?.assetTypeValue === CONSTANTS.CONSTRUCTION_EQUIPMENT ? <>
          <EqClassCodeField 
            catalogItemValues={catalogItemValues} 
            handleOnChange={handleOnChange} 
            catalogItemErrors={catalogItemErrors}  
            onPopupFilterModel={props?.onPopupFilterModel} 
            eqClassCodeOption={props?.eqClassCodeOption} 
            handleClickShowEqClassCodeList={props?.handleClickShowEqClassCodeList}
            />
        </> : null
      }
      <Col
        xs={12}
        sm={4}
        md={assetTypeValue === CONSTANTS.VEHICLE ? 6 : 3}
        lg={assetTypeValue === CONSTANTS.VEHICLE ? 6 : 3}
        xl={assetTypeValue === CONSTANTS.VEHICLE ? 6 : 3}
        className='mb-3 tooltip-description'
      >
        <Label required data-attribute="AssetType_Default_Label_35">LEADR Description</Label>
        <Tooltip content={catalogItemValues?.catalogDescription ? catalogItemValues?.catalogDescription : null} data-attribute="AssetType_Default_Tooltip_35">
        <InputField
          name='catalogDescription'
          placeholder='Enter LEADR Description'
          onChange={(e: any) => handleOnChange(e?.target?.value, e?.target?.name)}
          value={catalogItemValues?.catalogDescription}
          className={catalogItemErrors?.catalogDescription ? 'controlValidation' : "" }
         data-attribute="AssetType_catalogDescription_Input" />
        </Tooltip>
        {catalogItemErrors?.catalogDescription ? <p className='validMessage'>{catalogItemErrors?.catalogDescription}</p> : ""}
      </Col>
      {catalogItemValues?.vehicleType?.orderRequestType == CONSTANTS.PRODUCTION_VEHICLE &&
      <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-width'>
        <div className="label-addnew-block">
          <Label required data-attribute="AssetType_Default_Label_36">Snow Setup</Label>
        </div>
        <Tooltip content={catalogItemValues?.snowSetup?.label ?? ''}  data-attribute="AssetType_Default_Tooltip_36">
        <ReactSelectBox
          isSearchable = {true}
          name='snowSetup'
          placeholder="Select Snow Setup"
          options={props?.snowSetupOption}
          value={catalogItemValues?.snowSetup ?? ''}
          onChange={(selectedOption: any) => handleOnChange(selectedOption, 'snowSetup')}
          className={catalogItemErrors?.snowSetup ? 'controlValidation' : "" }
         data-attribute="AssetType_snowSetup_SearchSelectBox" />
        </Tooltip>
        {catalogItemErrors?.snowSetup ? <p className='validMessage'>{catalogItemErrors?.snowSetup}</p> : ""}
      </Col>}
      <Col xs={12} sm={4} md={6} lg={6} xl={6} className='mb-3 tooltip-description'>
        <Label required data-attribute="AssetType_Default_Label_37">EOne Description</Label>
        <Tooltip content={catalogItemValues?.eOneDescription ? catalogItemValues?.eOneDescription : null} data-attribute="AssetType_Default_Tooltip_37">
        <InputField
          name='eOneDescription'
          placeholder="Enter EOne Description"
          onChange={(e: any) => handleOnChange(e?.target?.value, e?.target?.name)}
          value={catalogItemValues?.eOneDescription}
          className={catalogItemErrors?.eOneDescription ? 'controlValidation' : "" }
         data-attribute="AssetType_eOneDescription_Input" />
        </Tooltip>
        {catalogItemErrors?.eOneDescription ? <p className='validMessage'>{catalogItemErrors?.eOneDescription}</p> : ""}
      </Col>
      {props?.assetTypeValue === CONSTANTS.MOWER ?
          <EqClassCodeField 
            catalogItemValues={catalogItemValues} 
            handleOnChange={handleOnChange} 
            catalogItemErrors={catalogItemErrors}  
            onPopupFilterModel={props?.onPopupFilterModel} 
            eqClassCodeOption={props?.eqClassCodeOption} 
            handleClickShowEqClassCodeList={props?.handleClickShowEqClassCodeList}
            />
        : null
      }
      <Col xs={12} sm={4} md={6} lg={6} xl={6} className='mb-3 tooltip-description'>
        <Label required data-attribute="AssetType_Default_Label_38">Detailed Description</Label>
        <Tooltip content={catalogItemValues?.detailedDescription ? catalogItemValues?.detailedDescription : null} data-attribute="AssetType_Default_Tooltip_38">
        <InputField
          name='detailedDescription'
          placeholder='Enter Detailed Description'
          onChange={(e: any) => handleOnChange(e?.target?.value, e?.target?.name)}
          value={catalogItemValues?.detailedDescription}
          className={catalogItemErrors?.detailedDescription ? 'controlValidation' : "" }
         data-attribute="AssetType_detailedDescription_Input" />
        </Tooltip>
        {catalogItemErrors?.detailedDescription ? <p className='validMessage'>{catalogItemErrors?.detailedDescription}</p> : ""}
      </Col>
      <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-description'>
        <Label required data-attribute="AssetType_Default_Label_39">PO Description 1</Label>
        <Tooltip content={catalogItemValues?.poDescription1 ? catalogItemValues?.poDescription1 : null} data-attribute="AssetType_Default_Tooltip_39">
        <InputField
          name='poDescription1'
          placeholder="Enter PO Description 1"
          onChange={(e: any) => handleOnChange(e?.target?.value, e?.target?.name)}
          value={catalogItemValues?.poDescription1}
          className={catalogItemErrors?.poDescription1 ? 'controlValidation' : "" }
         data-attribute="AssetType_poDescription1_Input" />
        </Tooltip>
        {catalogItemErrors?.poDescription1 ? <p className='validMessage'>{catalogItemErrors?.poDescription1}</p> : ""}
      </Col>
      <Col xs={12} sm={4} md={3} lg={3} xl={3} className='mb-3 tooltip-description'>
        <Label required data-attribute="AssetType_Default_Label_40">PO Description 2</Label>
        <Tooltip content={catalogItemValues?.poDescription2 ? catalogItemValues?.poDescription2 : null} data-attribute="AssetType_Default_Tooltip_40">
        <InputField
          name='poDescription2'
          placeholder="Enter PO Description 2"
          onChange={(e: any) => handleOnChange(e?.target?.value, e?.target?.name)}
          value={catalogItemValues?.poDescription2}
          className={catalogItemErrors?.poDescription2 ? 'controlValidation' : "" }
         data-attribute="AssetType_poDescription2_Input" />
        </Tooltip>
        {catalogItemErrors?.poDescription2 ? <p className='validMessage'>{catalogItemErrors?.poDescription2}</p> : ""}
      </Col>
    </Row>
    {
        props?.showEqClassCodeListModal ? 
        <ModalPopup
          ShowModalPopupFooter={false}
          ModalPopupTitle="EQ CLASS CODE LIST"
          ModalPopupType="medium-large"
          closeModalPopup={props?.handleClickShowEqClassCodeList}
          ModalPopupName = "eqClassCodeList-popup"
         data-attribute="AssetType_Default_ModalPopup"><EqClassCodeList/></ModalPopup> : ''
      }
  </>
  )
}
export default AssetType